import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LIVE_SESSIONS_TRANSLATION_KEY } from "../constants";
var en = /*#__PURE__*/_defineProperty({}, LIVE_SESSIONS_TRANSLATION_KEY, {
  SEARCH_SESSION: 'Search Session',
  CTA_UPDATE_SESSIONS_LIST: 'Update',
  DATE_SESSIONS_HEADER_TODAY: 'Sessions for Today',
  DATE_SESSIONS_HEADER_TOMORROW: 'Tomorrow {{date}}',
  DATE_SESSIONS_CARD_GUESTS: '{{guests}} guest',
  DATE_SESSIONS_CARD_GUESTS_plural: '{{guests}} guests',
  NO_PAST_SESSIONS: 'You have no past sessions',
  NO_UPCOMING_SESSIONS: 'You have no upcoming sessions created',
  NO_UPCOMING_SESSIONS_DESCRIPTION: 'Start creating dynamic learning environments for your collaborators',
  SESSION_CARD_CTA_DETAIL: 'View Detail',
  SESSION_CARD_CTA_EDIT: 'Edit Session',
  SESSION_CARD_CTA_ADD_USERS: 'Add participants',
  SESSION_CARD_CTA_ASSISTANCE: 'Add assistance',
  SESSION_CARD_CTA_DELETE: 'Delete Session',
  SESSION_CARD_LINK_PLACEHOLDER: 'Virtual Event',
  NO_RESULTS_FOUND: 'No results found for',
  SESSION_START_IN: 'Your session starts in {{min}} MIN',
  SESSION_LIVE_TAG: 'Live',
  ON_LIVE: 'Live',
  GET_INTO: 'Enter',
  SESSION_IN_PROGRESS: 'In Progress',
  NO_UPCOMING_SESSIONS_COLLABORATOR: 'You have no scheduled sessions at the moment',
  NO_PAST_SESSIONS_COLLABORATOR: 'You have no past sessions at the moment',
  GUESTS_TABLE_TITLE: 'Participants',
  GUESTS_TABLE_SUBTITLE: 'Here you can see all users of the organization.',
  GUESTS_TABLE_SEARCH: 'Search by name, last name, or email',
  GUESTS_TABLE_TOTAL_SELECTED_ACCEPT: 'selected on this page.',
  GUESTS_TABLE_TOTAL_SELECTED_CANCEL: 'selected in total.',
  GUESTS_TABLE_FILTER: 'Filter by',
  GUESTS_TABLE_SELECT_ALL: 'Select all {{total}} items',
  GUESTS_TABLE_REMOVE_SELECTION: 'Remove selection',
  GUESTS_TABLE_COLUMN_NAME: 'Name',
  GUESTS_TABLE_COLUMN_MAIL: 'Email',
  GUESTS_TABLE_COLUMN_ATTRIBUTES: 'Attributes',
  DELETE_SESSION_DIALOG_TITLE: 'Do you want to delete {{sessionTitle}}?',
  DELETE_SESSION_DIALOG_SUBTITLE: 'By deleting the session, any collaborator with the QR and/or link, when entering will show an error page.',
  DELETE_SESSION_DIALOG_CANCEL: 'Cancel',
  DELETE_SESSION_DIALOG_DELETE: 'Delete',
  BLOCKED_SCREEN_DEVELOPMENT: 'Development',
  BLOCKED_SCREEN_TITLE: 'Generate live activities with your team',
  BLOCKED_SCREEN_SUBTITLE: 'Create live sessions allowing real-time interaction and fostering more participatory learning',
  BLOCKED_SCREEN_DEMO_CTA: 'Request free demo',
  BLOCKED_SCREEN_DEMO_VIDEO: 'Watch video',
  BLOCKED_SCREEN_CARDS_TITLE: 'What will you have access to?',
  BLOCKED_SCREEN_FIRST_CARD_TITLE: 'Program live sessions',
  BLOCKED_SCREEN_FIRST_CARD_DESCRIPTION: 'Create in-person or virtual sessions, invitations will be sent to your users via email.',
  BLOCKED_SCREEN_SECOND_CARD_TITLE: 'Session Recording',
  BLOCKED_SCREEN_SECOND_CARD_DESCRIPTION: 'Upload the recording and complementary files to your session.',
  BLOCKED_SCREEN_THIRD_CARD_TITLE: 'Record Attendance',
  BLOCKED_SCREEN_THIRD_CARD_DESCRIPTION: 'Keep track of the people who attended your session within the platform.',
  BLOCKED_SCREEN_DEMO_DIALOG_TITLE: 'Do you want to request a free demo of Elevate Plus?',
  BLOCKED_SCREEN_DEMO_DIALOG_SUBTITLE: 'The features of Elevate LXP are available within the Elevate Plus plan. Request a demo and upgrade your plan to start managing your own content.',
  BLOCKED_SCREEN_DEMO_DIALOG_CTA: 'Yes, request',
  BLOCKED_SCREEN_DEMO_DIALOG_CANCEL: 'Cancel',
  SESSIONS_LIST_ERROR_TITLE: 'There was an error loading sessions',
  SESSIONS_LIST_ERROR_SUBTITLE: 'Click the button to try loading again.',
  SESSIONS_LIST_ERROR_CTA: 'Retry',
  NEW_LIVE_SESSION_TAG: 'New session',
  GUEST_CARD_TITLE: 'Participants',
  GUEST_TABLE_NAME_COLUMN: 'Name',
  GUEST_TABLE_CONFIRMATION_COLUMN: 'Confirmation',
  GUEST_TABLE_ACTIONS_COLUMN: 'Actions',
  GUEST_CARD_SEARCH: 'Search',
  GUEST_CARD_NO_GUEST_TITLE: 'You have not added any participants yet',
  GUEST_CARD_NO_GUEST_SUBTITLE: 'Remember to do so to send them the notification',
  GUESTS_TABLE_ASSIST_CTA: 'Attended',
  GUEST_TABLE_ASSISTANCE_COLUMN: 'Assistance',
  TOOLTIP_CONFIRMED_PARTICIPANTS_COUNT: 'Confirmed',
  TOOLTIP_ADD_PARTICIPANTS_CTA: 'Add participants',
  TOOLTIP_INVITED_COUNT: 'Invited',
  TOOLTIP_CANT_REMOVE_PARTICIPANT: 'You cannot remove confirmed participants',
  TOOLTIP_ASSIST_COUNT: 'Attended',
  TOOLTIP_ASSIST_BUTTON: 'Select who has participated to mark them as attended',
  TOOLTIP_NO_PRESENT_ACTION: 'You must mark the user as present to access more actions',
  COPY_LINK: 'Copy link',
  VIRTUAL: 'Virtual',
  PRESENTIAL: 'Presential',
  SESSION_IN_COURSE_TAG: 'Session as a class',
  SEND_MESSAGE: 'Send message',
  USER_SELECTION_PAGE_ALL: 'Select all {{count}} items',
  USER_SELECTION_PAGE: ' selected on this page.',
  TOOLTIP_REMOVE_ASSISTANCE: 'Removing assistance is not reversible. If you do, you will need to mark it manually.',
  DELETE_USER: 'Delete participant'
});
export default en;